export const handleParseDecimal = (value, isInt = true) => {
  const result = isInt
    ? (parseFloat(value) / 100).toString()
    : (parseFloat(value) * 100).toString();
  return result;
};
